import { GetServerSideProps } from 'next'
import React, { FC } from 'react'

import { Deserializer } from 'jsonapi-serializer'
import qs from 'qs'
import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'

import SearchView from '~/views/Search/Search.view'

import { getListings } from '~/hooks/requests/useListings'
import { parseSearchToParams } from '~/hooks/useSearchHandler'
import EmpriseGroup from '~/services/EmpriseGroup'
import parseRedirectParams from '~/services/Search/utils/getRedirectParams'
import Paths from '~/utils/paths'

import { CACHE_KEYS } from '~/constants'

const Search: FC = (props) => {
  return <SearchView {...props} />
}
export const getServerSideProps: GetServerSideProps = async (context) => {
  const { by_type, ...value } = context?.query
  const queryString = qs.stringify(value, { addQueryPrefix: true })
  const url = context?.resolvedUrl?.split('?')[0]

  const keyPath = by_type ? `${url}${queryString}` : context?.resolvedUrl

  try {
    const queryKey = [CACHE_KEYS.listings, keyPath]
    /* Set token */
    EmpriseGroup.setAuthToken(context.req.cookies.token)

    /* Handle redirect */
    const searchParams = parseSearchToParams(context.resolvedUrl)
    const redirectParams = parseRedirectParams(
      context.resolvedUrl,
      searchParams.formValues
    )

    const isRedirect = redirectParams.redirect || searchParams.redirect

    if (isRedirect) {
      const destination = {
        ...(searchParams.redirect && searchParams.formValues),
        ...(redirectParams.redirect && redirectParams.params)
      }

      const destinationPath = Paths.search.buildSearch(destination)

      if (context.resolvedUrl !== destinationPath) {
        return {
          redirect: {
            destination: destinationPath,
            statusCode: 301
          }
        }
      }
    }

    /* Prefetching data */
    const queryClient = new QueryClient()
    await queryClient.prefetchQuery(queryKey, () =>
      getListings(searchParams.params)
    )

    if (searchParams.params.by_type) {
      await queryClient.prefetchQuery(['main_categories'], () =>
        EmpriseGroup.getMainCategories().then(async (resp) => {
          return resp
        })
      )
    }

    if (searchParams.params.by_category) {
      await queryClient.prefetchQuery(
        ['product_subcategories', searchParams.params.by_type],
        () =>
          EmpriseGroup.getCategories({
            type_name: searchParams.params.by_type
          }).then(async (resp) => {
            const subcategories = await Deserializer.deserialize(resp)

            return subcategories
          })
      )
    }

    const state = queryClient.getQueryState(queryKey)

    /* Handle error state */
    if (state.status === 'error') {
      return { notFound: true }
    }

    return {
      props: {
        initialParams: JSON.parse(JSON.stringify(searchParams.params)) || {},
        dehydratedState: dehydrate(queryClient)
      }
    }
  } catch (error) {
    return { notFound: true }
  }
}

export default Search
